// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__sDfDj","dropdown":"default_dropdown__6em6p","dropdown__label":"default_dropdown__label__H6d-x","icon":"default_icon__gWy8U"};